jQuery(function ($) {
  $(document.body).on("click", ".conf_link" ,function(e) {
    e.preventDefault();

    var targetUrl = $(this).attr("href");
    var bodyText = 'Are you sure you want to delete this?';
    var targetAction = false;
    var targetID = '';

    if ($(this).data('conf-msg')) {
      bodyText = $(this).data('conf-msg');
    }

    if ($(this).data('action')) {
      targetAction = $(this).data('action');
      targetID = $(this).data('id');
    }

    var modal = $('<div class="modal" tabindex="-1"><div class="modal-dialog modal-dialog-centered"><div class="modal-content"><div class="modal-header bg-danger text-white"><h5 class="modal-title">Are you sure?</h5><button type="button" class="close text-white" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><p>' + bodyText + '</p></div><div class="modal-footer"><button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button><button type="button" class="btn btn-success confirm-btn">Confirm</button></div></div></div></div>');

    $('body').append(modal);
    modal.modal('show');
    $(document).on('click', '.confirm-btn', function(e){
      e.preventDefault();
      if (targetAction) {
        window[targetAction](targetID);
        modal.modal('hide').remove();
      } else {
        window.location.href = targetUrl;
        modal.modal('hide').remove();
      }
    });

  });
});